"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformContext = exports.PerformActionsContext = exports.PerformController = void 0;
const getEnabledQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getEnabledQuestions"));
const getPercentCompletion_1 = __importDefault(require("@opsbase/lib-form/helpers/getPercentCompletion"));
const getScore_1 = __importDefault(require("@opsbase/lib-form/helpers/getScore"));
const isAnswerableQuestion_1 = __importDefault(require("@opsbase/lib-form/helpers/isAnswerableQuestion"));
const isFailed_1 = __importDefault(require("@opsbase/lib-form/helpers/isFailed"));
const isValidAnswer_1 = __importDefault(require("@opsbase/lib-form/helpers/isValidAnswer"));
const updateActiveQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/updateActiveQuestions"));
const addARepetition_1 = __importDefault(require("@opsbase/lib-form/mutations/addARepetition"));
const removeARepetition_1 = __importDefault(require("@opsbase/lib-form/mutations/removeARepetition"));
const getPassStatusColor_1 = __importDefault(require("@opsbase/lib-grading/getPassStatusColor"));
const calcGrade_1 = __importDefault(require("@opsbase/lib-grading/helpers/calcGrade"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const react_1 = __importStar(require("react"));
const g = function (f) {
    return f.current;
};
const s = (r, v) => (r.current = v);
function PerformController(props) {
    var _a, _b;
    const { id, form, isSubmitted, isScoreEnabled, isScorePublic, isGradingPublic, allowIssuesAndNotes, canBePerformedOnlyOnNative, gradingMethod, isPreview, title, saving = false, placeId, placeTitle, children, onSubmit, onUpdate, selectedQuestionId, onChangeSelectedQuestionId, alwaysShowScoreWhenEnabled, onAddConversation, mode = 'edit', } = props;
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const self = (0, useSelf_1.default)();
    const activeQuestions = (0, react_1.useRef)([]);
    const selectedNodeId = (0, react_1.useRef)();
    const percentCompleted = (0, react_1.useRef)(0);
    const submitting = (0, react_1.useRef)(false);
    const scoreText = (0, react_1.useRef)();
    const grade = (0, react_1.useRef)();
    const status = (0, react_1.useRef)();
    const passStatus = (0, react_1.useRef)();
    const passStatusColor = (0, react_1.useRef)();
    const isPassStatusAvailable = (0, react_1.useRef)();
    const isGradeAvailable = (0, react_1.useRef)();
    const isScoreAvailable = (0, react_1.useRef)();
    const isCompleted = (0, react_1.useRef)();
    const isFail = (0, react_1.useRef)();
    const submittedBy = (0, react_1.useRef)();
    const userImage = (0, react_1.useRef)();
    const hasError = (0, react_1.useRef)(false);
    const grades = (_a = self === null || self === void 0 ? void 0 : self.settings) === null || _a === void 0 ? void 0 : _a.grades;
    const gradingCalculators = (_b = self === null || self === void 0 ? void 0 : self.settings) === null || _b === void 0 ? void 0 : _b.gradingCalculators;
    const _doRecalc = (0, react_1.useMemo)(() => () => {
        (0, updateActiveQuestions_1.default)(form);
        s(activeQuestions, (0, getEnabledQuestions_1.default)(form.questionTree));
        s(percentCompleted, (0, getPercentCompletion_1.default)(form));
        s(isCompleted, g(percentCompleted) === 100);
        s(isScoreAvailable, (g(isCompleted) || alwaysShowScoreWhenEnabled) && isScoreEnabled && isScorePublic);
        s(isGradeAvailable, (g(isCompleted) || alwaysShowScoreWhenEnabled) && isGradingPublic);
        const score = (0, getScore_1.default)(form);
        s(scoreText, `${score.total}/${score.max}`);
        const didFail = (0, isFailed_1.default)(form);
        const { grade: newGrade, passStatus: newPassStatus } = (0, calcGrade_1.default)(gradingMethod, isScoreEnabled, didFail, grades, gradingCalculators, score, g(isCompleted));
        s(grade, newGrade);
        s(passStatus, newPassStatus);
        s(isFail, didFail);
        s(isPassStatusAvailable, g(isScoreAvailable) && !!g(passStatus));
        s(isGradeAvailable, g(isGradeAvailable) && !!g(grade));
        s(isScoreAvailable, g(isScoreAvailable) && !!g(scoreText));
        s(passStatusColor, g(isPassStatusAvailable) ? (0, getPassStatusColor_1.default)(g(passStatus)) : undefined);
        setCtxChanged(new Date());
    }, [
        alwaysShowScoreWhenEnabled,
        form,
        grades,
        gradingCalculators,
        gradingMethod,
        isGradingPublic,
        isScoreEnabled,
        isScorePublic,
    ]);
    const doSetHasError = (0, react_1.useMemo)(() => (error) => {
        hasError.current = error;
    }, []);
    const _doGetSibling = (0, react_1.useMemo)(() => (questionNodeId, dir, unanswered = false) => {
        const qs = g(activeQuestions);
        const as = form.answers;
        const rs = form.rules;
        // What is our current position in the list of questions?
        let qIdx = qs.findIndex(q => q.nodeId === questionNodeId);
        // Keep looking until we find our appropriate sibling
        while (true) {
            // What is the position in the list of the next/previous sibling
            let siblingIdx = null;
            if (dir === 1 && qIdx < qs.length - 1)
                siblingIdx = qIdx + 1;
            else if (dir === -1 && qIdx > 0)
                siblingIdx = qIdx - 1;
            // We're at the start or end of the list
            if (siblingIdx === null)
                return undefined;
            // Now check the sibling matches our needs
            const sibling = qs[siblingIdx];
            // Unanswerable questions (e.g. Info questions) are ignored
            if (!(0, isAnswerableQuestion_1.default)(sibling))
                qIdx = siblingIdx;
            // Are we looking for just "unanswered" questions?
            else if (unanswered &&
                (0, isValidAnswer_1.default)(as[sibling.nodeId], sibling, rs[sibling.questionId]))
                qIdx = siblingIdx;
            // Otherwise, we've found what we want
            else
                return sibling;
        }
    }, [form]);
    (0, react_1.useEffect)(() => {
        _doRecalc();
    }, [_doRecalc, isScorePublic, isScoreEnabled, isGradingPublic, gradingMethod, form]);
    (0, react_1.useEffect)(() => {
        var _a;
        const n = selectedNodeId.current;
        if (!form.questions[n]) {
            selectedNodeId.current = undefined;
            setCtxChanged(new Date());
            return;
        }
        if (n && selectedQuestionId && form.questions[n].questionId === selectedQuestionId)
            return;
        if (!selectedQuestionId && !n)
            return;
        if (!selectedQuestionId)
            selectedNodeId.current = undefined;
        if (selectedQuestionId)
            selectedNodeId.current = (_a = Object.values(form.questions).find(q => q.questionId === selectedQuestionId)) === null || _a === void 0 ? void 0 : _a.nodeId;
        setCtxChanged(new Date());
    }, [form, selectedQuestionId]);
    const listeners = (0, react_1.useRef)({
        answered: [],
    });
    const addListener = (0, react_1.useCallback)((type, fn) => {
        listeners.current[type].push(fn);
    }, []);
    const removeListener = (0, react_1.useCallback)((type, fn) => {
        const index = listeners.current[type].findIndex(z => z === fn);
        if (index > -1)
            listeners.current[type].splice(index, 1);
    }, []);
    const doUpdateAnswer = (0, react_1.useMemo)(() => (questionNodeId, newAnswer) => {
        form.answers[questionNodeId] = newAnswer;
        (0, updateActiveQuestions_1.default)(form);
        _doRecalc();
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(form);
        listeners.current['answered'].forEach(fn => fn({ nodeId: questionNodeId, answer: newAnswer }));
    }, [_doRecalc, form, onUpdate]);
    const doUpdateSubmittingUser = (0, react_1.useMemo)(() => (staff) => {
        s(submittedBy, staff);
    }, [submittedBy]);
    const doSetUserImage = (0, react_1.useMemo)(() => (value) => {
        s(userImage, value);
    }, [userImage]);
    const doSubmit = (0, react_1.useMemo)(() => () => {
        submitting.current = true;
        setCtxChanged(new Date());
        onSubmit(form, submittedBy.current, userImage.current)
            .then(() => {
            submitting.current = false;
            setCtxChanged(new Date());
        })
            .catch(() => {
            submitting.current = false;
            setCtxChanged(new Date());
        });
    }, [form, onSubmit]);
    const doSelectNode = (0, react_1.useMemo)(() => (questionNodeId) => {
        onChangeSelectedQuestionId === null || onChangeSelectedQuestionId === void 0 ? void 0 : onChangeSelectedQuestionId(form.questions[questionNodeId].questionId);
        s(selectedNodeId, questionNodeId);
        setCtxChanged(new Date());
    }, [onChangeSelectedQuestionId, form]);
    const doSelectSiblingNode = (0, react_1.useMemo)(() => (questionNodeId, dir, unanswered) => {
        const sibling = _doGetSibling(questionNodeId, dir, unanswered);
        if (sibling)
            doSelectNode(sibling.nodeId);
    }, [_doGetSibling, doSelectNode]);
    const hasSiblingNode = (0, react_1.useMemo)(() => (questionNodeId, dir, unanswered) => {
        return !!_doGetSibling(questionNodeId, dir, unanswered);
    }, [_doGetSibling]);
    const doAddRepNode = (0, react_1.useMemo)(() => (questionNodeId, index) => {
        (0, addARepetition_1.default)(form, questionNodeId, index);
        _doRecalc();
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(form);
    }, [_doRecalc, form, onUpdate]);
    const doDeleteRepNode = (0, react_1.useMemo)(() => (questionNodeId) => {
        (0, removeARepetition_1.default)(form, questionNodeId);
        _doRecalc();
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(form);
    }, [_doRecalc, form, onUpdate]);
    const doAddConversation = (0, react_1.useCallback)((conversationId) => onAddConversation === null || onAddConversation === void 0 ? void 0 : onAddConversation(conversationId), [onAddConversation]);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        doUpdateAnswer,
        doUpdateSubmittingUser: doUpdateSubmittingUser,
        doSetUserImage,
        doSubmit,
        doSelectNode,
        doSelectSiblingNode,
        doAddRepNode,
        doDeleteRepNode,
        hasSiblingNode,
        doSetHasError,
        doAddConversation,
        addListener,
        removeListener,
    }), [
        doUpdateAnswer,
        doUpdateSubmittingUser,
        doSetUserImage,
        doSubmit,
        doSelectNode,
        doSelectSiblingNode,
        doAddRepNode,
        doDeleteRepNode,
        hasSiblingNode,
        doSetHasError,
        doAddConversation,
        addListener,
        removeListener,
    ]);
    const ctx = (0, react_1.useMemo)(() => {
        return {
            id,
            title,
            placeId,
            placeTitle,
            form,
            isSubmitted,
            isScoreEnabled,
            isScorePublic,
            isGradingPublic,
            allowIssuesAndNotes,
            canBePerformedOnlyOnNative,
            gradingMethod,
            saving,
            selectedNodeId: selectedNodeId.current,
            activeQuestions: activeQuestions.current,
            percentCompleted: percentCompleted.current,
            submitting: submitting.current,
            scoreText: scoreText.current,
            grade: grade.current,
            passStatus: passStatus.current,
            passStatusColor: passStatusColor.current,
            status: status.current,
            isFail: isFail.current,
            isCompleted: isCompleted.current,
            isPassStatusAvailable: isPassStatusAvailable.current,
            isGradeAvailable: isGradeAvailable.current,
            isScoreAvailable: isScoreAvailable.current,
            alwaysShowScoreWhenEnabled,
            submittedBy: submittedBy.current,
            hasError: hasError.current,
            isPreview,
            mode,
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged, saving]);
    return (react_1.default.createElement(exports.PerformActionsContext.Provider, { value: actionsCtx },
        react_1.default.createElement(exports.PerformContext.Provider, { value: ctx }, children)));
}
exports.PerformController = PerformController;
exports.default = PerformController;
exports.PerformActionsContext = react_1.default.createContext(null);
exports.PerformContext = react_1.default.createContext(null);
